import Skeleton from '@mui/material/Skeleton';

export const DeliveryOptionSkeleton = () => {
  return <Skeleton animation="wave" variant="rounded" width={116} height={95} />;
};
